import { render } from "./TrainingSettings.vue?vue&type=template&id=c54e5516&scoped=true&ts=true"
import script from "./TrainingSettings.vue?vue&type=script&lang=ts"
export * from "./TrainingSettings.vue?vue&type=script&lang=ts"

import "./TrainingSettings.vue?vue&type=style&index=0&id=c54e5516&scoped=true&lang=css"

import exportComponent from "/Users/eugene/My/Projects/ek22f/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54e5516"]])

export default __exports__